module.exports = __webpack_public_path__ + "static/media/logo-black.01687616.png";